import React, { FC } from 'react';
import { DataObjectFormDataType } from '@atlas-frontend/sdk';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';

export interface DataObjectBreadcrumbsData {
  dataObjectVersion?: DataObjectFormDataType;
}

export type DataObjectBreadcrumbsProps =
  SectionBreadcrumbsProps<DataObjectBreadcrumbsData>;

export const DataObjectBreadcrumbs: FC<DataObjectBreadcrumbsProps> = (
  props
) => <SectionBreadcrumbs {...props} routes={props.routes} />;
